export const ORGANIZATIONS_URL_PART = 'organizations'
